import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_URL}/api/client/document`;

// 🔐 Helper: Auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenInv");
  return {
    Authorization: `Bearer ${token}`,
    "ngrok-skip-browser-warning": "true",
  };
};

// 📄 Get Document List
export const fetchDocuments = async (filters = {}) => {
  const {
    vendor_id = null,
    page = 1,
    per_page = 10,
  } = filters;

  // Conditionally build params object
  const params = {
    page,     
    per_page,
  };

  if (vendor_id !== -1 && vendor_id !== null && vendor_id !== undefined) {
    params.vendor_id = vendor_id;
  }

  const response = await axios.get(`${API_BASE_URL}/list`, {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
};


// 📤 Upload Document
export const uploadDocument = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// ✅ Validate Document
export const validateDocument = async (documentId) => {
  const response = await axios.post(
    `${API_BASE_URL}/validate/${documentId}`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// 🚀 Send Document to Process
export const sendDocumentToProcess = async (documentId) => {
  const response = await axios.post(
    `${API_BASE_URL}/send_to_process/${documentId}`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// 📂 Folder CRUD
export const fetchFolders = async () => {
  const response = await axios.get(`${API_BASE_URL}/folder`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchFolderReport = async () => {
  const response = await axios.get(`${API_BASE_URL}/folder/report`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const moveDocumentToFolder = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/folder/file`, data, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const fetchFolderRecords = async (folderId, page = 1, perPage = 200, category = null, hubStatus = null) => {
  let url = `${API_BASE_URL}/folder/records?folder_id=${folderId}&page=${page}&per_page=${perPage}`;
  if (category) url += `&category=${encodeURIComponent(category)}`;
  if (hubStatus) url += `&hub_status=${encodeURIComponent(hubStatus)}`;

  const response = await axios.get(url, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createFolder = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/folder`, data, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updateFolder = async (id, data) => {
  const response = await axios.put(`${API_BASE_URL}/folder/${id}`, data, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const deleteFolder = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/folder/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
